import { Record, Map, List } from 'immutable'
import { USA_ISO, USA_CODE } from 'app/constants/phoneCountryCodes'

const LocalSettingsRecord = Record(
  {
    isOneSignalInitialized: false,
    isTopNotificationBlockShown: null,
    isPushEnabled: false,
    isOptedOut: false,
    isNotificationsBlocked: false, // not available by browser, or user block it manually
    isPending: false,
    isShowConfirmationModalForSwitchProTrack: false,
    isShowConfirmationModalForStopProTrack: false,
    isShowConfirmationModalForDifferentProTrack: false,
    isShowLoginInformationModal: false,
    isShowConfirmationModalForCommitPreviousActivity: false,
    loadedLanguages: Map(),
    queries: Map(),
    countriesCodes: List([Map({ country: USA_ISO, code: USA_CODE })]),
  },
  'LocalSettings'
)

export default class LocalSettings extends LocalSettingsRecord {}
